// serviceWorkerRegistration.js

// Check if service workers are supported
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register() {
    if ('serviceWorker' in navigator) {
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) {
            return;
        }

        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            if (isLocalhost) {
                // Localhost: check if service worker exists
                checkValidServiceWorker(swUrl);
                navigator.serviceWorker.ready.then(() => {
                    console.log('Service worker ready (localhost)');
                });
            } else {
                // Register service worker for production
                registerValidSW(swUrl);
            }
        });
        navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data && event.data.type === "NEW_VERSION_AVAILABLE") {
                showUpdateToast();
            }
        });
    }
}

function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            console.log('Service Worker registered:', registration);
        })
        .catch((error) => {
            console.error('Error during service worker registration:', error);
        });
}

function checkValidServiceWorker(swUrl) {
    fetch(swUrl)
        .then((response) => {
            const contentType = response.headers.get('content-type');
            if (
                response.status === 404 ||
                (contentType && contentType.indexOf('javascript') === -1)
            ) {
                // No service worker found
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                });
            } else {
                // Found valid service worker
                registerValidSW(swUrl);
            }
        })
        .catch(() => {
            console.log('No internet connection found. App running offline.');
        });
}


function showUpdateToast() {
    const toast = document.createElement("div");
    toast.textContent = "New version available — refreshing...";
    Object.assign(toast.style, {
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#01333e",
        color: "#fff",
        padding: "12px 20px",
        borderRadius: "10px",
        fontSize: "14px",
        zIndex: "9999",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        opacity: "0",
        transition: "opacity 0.5s ease-in-out",
    });

    document.body.appendChild(toast);

    // Fade in
    requestAnimationFrame(() => (toast.style.opacity = "1"));

    // Fade out before removal
    setTimeout(() => {
        toast.style.opacity = "0";
        setTimeout(() => toast.remove(), 500);
    }, 1800);
}